/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1BannerIdMutationResponse,
  DeleteApiV1BannerIdPathParams,
  DeleteApiV1BannerId401,
  DeleteApiV1BannerId404,
  DeleteApiV1BannerId500,
} from "../../types/bannerRegistroController/DeleteApiV1BannerId.ts";

function getDeleteApiV1BannerIdUrl(id: DeleteApiV1BannerIdPathParams["id"]) {
  const res = { method: "DELETE", url: `/api/v1/banner/${id}` as const };
  return res;
}

/**
 * @description Exclui o banner e todos os seus idiomas e turmas vinculados. **(Requer Authorization para autenticação)**
 * @summary Excluir banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:id}
 */
export async function deleteApiV1BannerId(
  id: DeleteApiV1BannerIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1BannerId401 | DeleteApiV1BannerId404 | DeleteApiV1BannerId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1BannerIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
